var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.roles,"label":_vm.$t('users.roles.title.singular')},model:{value:(_vm.role),callback:function ($$v) {_vm.role=$$v},expression:"role"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }